import { useQuery } from "@tanstack/react-query";
import http from "../services/api/utilities/http";


const fetcher = (url) =>
    url && http.get(url).then((res) => res.data.data);


export const useFetch = (url) => {
    const { data, error, isFetching, refetch } = useQuery({
        queryKey: [url],
        queryFn: () => fetcher(url),
        enabled: !!url,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });

    return {
        data,
        status: {
            isSuccess: !!data && !error,
            isLoading: isFetching,
            isError: !!error,
        },
        refetch,
    };
};
